import { combineReducers } from 'redux'
import current from './current'

export default combineReducers({
  current,
})
